import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker2 from '../../assets/images/contents/speaker2.jpg';

export const ProfessorRichardMillham = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">ProfessorDrRichardCMillham</li>
      </ol>
    </nav>
    {/* <h2>Abstract - Professor Dr. Richard C Millham</h2> <br/>   */}

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker2} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Professor Dr. Richard Millham</b>
    </p>

    <p style={{textAlign:'center'}}>
      Durban University of Technology
      Kwazulu Natal, South Africa
    </p>

    <address style={{textAlign:'center'}}>
      Email: <a href="mailto:richardm1@dut.ac.za">richardm1@dut.ac.za</a>
    </address>

    <br/>
    <br/>

    <h4 style={{textAlign:'center'}}>Use of Bio-inspired Algorithms for Intelligent Energy Management of Renewable Energy Resources</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      The impact of climate change, based primarily on the overuse of fossil fuels, has
      increased awareness of and interest in renewable energy. This is compounded by
      recent problems in South Africa, among other nations. In this talk, we will first outline
      how the use of renewable energy resources may mitigate climate change. Then, we
      will discuss how bio-inspired algorithms may play a role in smart energy management
      of both these renewable energy resources (the production side) and smart energy
      consumption (the load side) through dynamic optimization of load shifting and
      through optimal utilization of available renewable energy resources respectively.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      Richard Millham is currently an Associate Professor at Durban University of
      Technology in Durban, South Africa and adjunct professor of computer science at the
      University of Energy and Natural Resources in Ghana. After thirteen years of
      industrial experience, he switched to academe and has worked at universities in
      Ghana, South Sudan, Scotland, and Bahamas. His research interests include
      software evolution, aspects of cloud computing with m-interaction, big data, data
      streaming, fog and edge analytics, and aspects of the Internet of Things. He is a
      Chartered Engineer (UK), a Chartered Engineer Assessor, and Senior Member of
      IEEE.
    </p>


    <p>Click this <a href = "https://www.dut.ac.za/space_science/prof_millham/" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)